import React, {forwardRef, useEffect, useState} from 'react'
import {modelUtils} from "@/utils";
import {connect} from "dva";
import {ConfigProvider, Card, Form, Input, Spin, Button, Radio} from "antd5";
import {DatePicker, InputNumber, Modal, Table} from 'antd'
import moment from "moment/moment";

import zhCN from 'antd5/locale/zh_CN';
import {WizAuthority, WizTableForm} from "@/containers/common";
import {useUpdateEffect} from "ahooks";
import {Session} from "wiz-utils";
import {routerRedux} from "dva/router";
import {formatAuth} from "@/utils/commonUtils";
import {ChapterPreview} from "@/containers/online";

const reviewQuestionConfig = WizTableForm.Config.reviewQuestion(this, {apiParams: {state: 1}})


const {useForm, useWatch, Item} = Form

const Index = (
  {
    refInstance,
    dispatch,

    detailRes,
    saveRes,

    ReviewTaskLoading,
    ...props
  },
) => {
  const [id, setId] = useState();
  const [previewModal, setPreviewModal] = useState(false);
  const [form] = useForm();
  const questions = useWatch('questions', form)

  const {setFieldsValue, validateFields} = form

  useEffect(() => {
    console.log('props', props)
    const {history} = props || {}
    if (!history?.location?.pathname?.startsWith?.('/online/reviewTask/upd')) {
      return
    }
    const id = history?.location?.record?.id
    if (!!id) {
      setId(id)
      Session.set('reviewTaskDetail', id)
    } else {
      setId(Session.get('reviewTaskDetail'))
    }
  }, [])

  useUpdateEffect(() => {
    dispatch({
      type: "ReviewTask/getInfoById",
      payload: {
        key: "getInfoById",
        apiParams: {
          id: id,
        },
      },
    })
  }, [id])

  useUpdateEffect(() => {
    const {success, msg, data} = detailRes || {}
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙');
      return;
    }
    const {
      startDate,
      endDate,
      questions,
      ...other
    } = data || {}

    setFieldsValue({
      ...other,
      date: [moment(startDate), moment(endDate)],
      questions: questions?.map(item => ({
        ...item,
        questionId: item?.id,
      }))
    })
  }, [detailRes])

  const _onSubmit = () => {
    console.log('form', form)
    validateFields()
      .then(data => {
        const {
          date,
          questions,
          authInfo,
          ...other
        } = data
        const [startDate, endDate] = date

        return {
          startDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
          questionIds: questions?.map(item => item?.questionId),
          authCmd: formatAuth(authInfo),
          ...other,
        }
      })
      .then(data => {
        dispatch({
          type: !id ? "ReviewTask/add" : "ReviewTask/upd",
          payload: {
            key: "save",
            apiParams: {
              ...data,
              id: id,
            },
          },
        })
      })
      .catch(err => {
        console.log('_submit', 'err', err)
      })
  }

  useUpdateEffect(() => {
    const {success, msg, data} = saveRes || {}
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙');
      return;
    }
    wizNotice.success(msg);
    dispatch(routerRedux['replace']({pathname: '/online/reviewTask'}));
  }, [saveRes])


  const totalScore = questions?.map(item => item?.score || 0).reduce((a, b) => a + b, 0)

  return (
    <ConfigProvider locale={zhCN}>
      <Card>
        <Spin spinning={ReviewTaskLoading}>
          <Form form={form} labelCol={{span: 6}} wrapperCol={{span: 17}}>
            <Item label={'任务名称'} name={'title'}>
              <Input placeholder={'请输入任务名称'}/>
            </Item>

            <Item label={'任务时间'} name={'date'} rules={[]}>
              <DatePicker.RangePicker
                style={{width: '100%'}}
                showTime={{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }}
              />
            </Item>

            <Item label={'总分'}>
              {totalScore || 0}分
            </Item>

            <Item label={'通过分数'} name={'passScore'} rules={[{required: true, message: '请填写通过分数'}]}>
              <InputNumber style={{width: '100%'}} placeholder={'请填写通过分数'} min={0}/>
            </Item>

            <Item label={'限制时间（分）'} name={'limitMinutes'} initialValue={0}>
              <InputNumber style={{width: '100%'}} placeholder={'请填写通过分数'} min={0}/>
            </Item>

            <Item label={'限制次数'} name={'times'} initialValue={0}>
              <InputNumber style={{width: '100%'}} placeholder={'请填写通过分数'} min={0}/>
            </Item>

            <Item label={'是否显示标准答案'} help={'选择“是”则支持学员在学员端查看标准答案，“否”为不支持'}
                  name={'showAnswer'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Item>

            <Item label={'是否显示得分/失分记录'} help={'选择“是”则支持学员在学员端查看得分点和失分点，“否”为不支持'}
                  name={'showQuestionRule'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Item>
            <Item label={'开始人脸识别'} name={'openFace'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Item>
            <Item label={'开始声纹识别'} name={'openVoiceprint'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Item>

            <Item label={'任务描述'} name={'intro'}>
              <Input.TextArea placeholder={'请输入任务描述'}/>
            </Item>

            <Item label={'背景说明'} name={'backgroundNote'}>
              <Input.TextArea/>
            </Item>

            <Item label={'受众范围'} name={'authInfo'}>
              <WizAuthority
                mode={'Form'}
                keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']}
                hasRadioGroup={false}
              />
            </Item>

            <Item label={'题目内容'} name={'questions'} rules={[{required: true, message: '请选择题目内容'}]}>
              <FormTable
                lookQuestions={(data) => {
                  const _data = {
                    title: data?.title || '',
                    score: data?.score || 0,
                    questionIds: data?.questions?.map(({questionId, ...other}) => ({
                      ...other,
                      id: questionId,
                    })) || [],
                  }
                  setPreviewModal(_data)
                }}
              />
            </Item>

            <Item wrapperCol={{span: 24}}>
              <div style={{display: 'flex', justifyContent: 'center', gap: 20}}>
                <Button type={'primary'} onClick={_onSubmit}>保存</Button>
                <Button>重置</Button>
              </div>
            </Item>
          </Form>

          <Modal
            zIndex={1001}
            width={800}
            visible={!!previewModal}
            footer={<Button onClick={() => setPreviewModal(false)}>关 闭</Button>}
            onCancel={() => setPreviewModal(false)}
            destroyOnClose={true}
          >
            <ChapterPreview mode={1} {...previewModal}/>
          </Modal>
        </Spin>
      </Card>
    </ConfigProvider>

  )
}

const _getValue = (type, key) => {
  const values = {
    type: {
      0: '单选题',
      1: '多选题',
      2: '判断题',
      3: '填空题',
      4: '主观题',
      5: '主观题',
    },
    difficulty: {
      0: '低',
      1: '中',
      2: '高',
    },
  }
  return values[type][key]
}

const FormTable = ({value, onChange, lookQuestions}) => {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({current: 1, pageSize: 10})
  const [questionModalVisible, setQuestionModalVisible] = useState(false)

  const {current, pageSize} = pagination

  const _del = (index, record) => {
    setDataSource(dataSource?.filter((item, i) => !(index === i && record?.questionId === item?.questionId)))
  }

  const columns = [
    {title: '题目类型', dataIndex: 'type', render: (text) => _getValue('type', text) || text},
    {title: '题目编码', dataIndex: 'number'},
    {title: '题目内容', dataIndex: 'title'},
    {title: '题目难度', dataIndex: 'difficulty', render: (text) => _getValue('difficulty', text) || text},
    {title: '题目分数', dataIndex: 'score'},
    {title: '通过分数', dataIndex: 'passScore'},
    {
      title: '操作',
      fixed: 'right',
      render: (_, record, index) => (
        <span>
          <a onClick={() => _del((current - 1) * pageSize + index, record)}>删除</a>
        </span>
      ),
    },
  ]

  useEffect(() => {
    setDataSource(value || [])
  }, [value]);

  useUpdateEffect(() => {
    console.log('dataSource', dataSource)
  }, [dataSource])
  // 维护分页内容
  useUpdateEffect(() => {
    setPagination(pagination => ({
      ...pagination,
      current: Math.max(1, Math.min(pagination.current, Math.ceil(dataSource.length / pagination.pageSize)))
    }))
  }, [dataSource])
  // 回传form数据
  useUpdateEffect(() => {
    onChange && onChange(dataSource)
  }, [dataSource])


  return (
    <div>
      <div style={{display: 'flex', gap: 5}}>
        <WizTableForm
          key={Date.now()}
          {...reviewQuestionConfig}
          visible={!!questionModalVisible}
          onCancel={() => setQuestionModalVisible(false)}
          initRows={dataSource?.map(item => ({...item, id: item.questionId}))}
          value={dataSource?.map(item => item?.questionId)}
          onSubmit={(obj) => {
            setQuestionModalVisible(false)
            const list = obj.valueRows?.map(item => {
              const {
                id,
                difficulty,
                number,
                type,
                title,
                score,
                passScore,
              } = item

              return {
                questionId: id,
                title,
                difficulty,
                number,
                type,
                score,
                passScore,
                state: 1,
              }
            })
            setDataSource([...list])
            console.log('obj', obj)
          }}
          renderValue={() => <Button type={'primary'} onClick={() => setQuestionModalVisible(true)}>选择题目</Button>}
        />


        <Button
          onClick={() => {
            lookQuestions && lookQuestions({
              questions: dataSource || [],
            })

          }}>查看题目</Button>
      </div>
      <Table
        scroll={{x: 'max-content'}}
        columns={columns}
        pagination={pagination}
        onChange={(pagination) => setPagination(pagination)}
        dataSource={dataSource}
      />
    </div>
  )
}


const mapStateToProps = (state, ownProps) => {
  const {ReviewTask} = state;
  const getInfoById = modelUtils.getModelEntity(ReviewTask, "getInfoById");
  const save = modelUtils.getModelEntity(ReviewTask, "save");

  const loading = modelUtils.getLoadingState(state, ['ReviewTask']);

  return {
    detailRes: getInfoById,
    saveRes: save,
    ...loading,
  }
};
const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
export default forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>)

